// @flow

import React from "react";
import type { ResultItemContainerProps } from "../../../utils/_types";
import CategorizationSlot from "../ItemSlots/CategorizationSlot";
import ImageSlot from "../ItemSlots/ImageSlot";

import { format } from "date-fns";

const EventItem = ({ result, translations }: ResultItemContainerProps) => {
  const {
    title,
    "@id": url,
    start,
    end,
    description,
    image,
    event_category,
  } = result;
  const startDate = start ? format(new Date(start), "dd/MM/yyyy") : "";
  const endDate = end ? format(new Date(end), "dd/MM/yyyy") : "";
  const startHour = start ? format(new Date(start), "HH:mm") : "";
  const endHour = end ? format(new Date(end), "HH:mm") : "";
  const fromLabel = translations.from_label ? translations.from_label : "From";
  const toLabel = translations.to_label ? translations.to_label : "To";
  /*const onLabel = translations.single_day_label
    ? translations.single_day_label
    : 'On';
*/
  let eventDates = "";
  if (startDate === endDate) {
    eventDates = `${startDate} ${startHour} - ${endHour}`;
  } else {
    eventDates = `${fromLabel} ${startDate} ${startHour} ${toLabel} ${endDate} ${endHour}`;
  }
  eventDates = `${startDate}`;

  const keepReadingLabel = translations
    ? translations.keep_reading_label
    : "Keep reading";
  return (
    <div className="result-item">
      <ImageSlot image={image} />
      <div className="data">
        <div className="info">
          <CategorizationSlot category={event_category} />

          <div className="date">
            <i className="fas fa-calendar-alt" /> {eventDates}
          </div>
        </div>
        <h3>{title}</h3>
        {description.length ? <p className="description">{description}</p> : ""}
        <p className="keep-reading">
          <a href={url} title={keepReadingLabel}>
            {keepReadingLabel}
            <i className="fas fa-angle-right" />
          </a>
        </p>
      </div>
    </div>
  );
};

export default EventItem;
